import { TApiaSelectPossibleValue } from '@apia/util';
import { unableToSetValueError } from './unableToSetValueError';

export const getPossibleValue = (
  possibleValues: TApiaSelectPossibleValue[],
  actualValue: any,
  fieldName: string,
  fieldValue: any,
  prevLabel: string | number | boolean | null,
  value: string,
) => {
  const returnValue: {
    actualValue?: any;
    prevLabel?: string | number | boolean | null;
  } = { prevLabel, actualValue };
  for (const possible of possibleValues) {
    if (possible.label === value) returnValue.actualValue = possible.value;
    if (fieldValue instanceof Array) {
      if (possible.value === '') continue;
      const fieldValueIdx = fieldValue.indexOf(possible.value);
      if (-1 !== fieldValueIdx) returnValue.prevLabel = possible.label;
    } else if (possible.value === fieldValue)
      returnValue.prevLabel = possible.label;
  }
  if (!returnValue.actualValue)
    unableToSetValueError(fieldName, value, possibleValues);
  return returnValue;
};
